// frontend/modules/notification-config/routes.tsx
import * as React from 'react';
import { Route, RouteObject } from 'react-router-dom';
import { NotificationConfigListView } from './views/NotificationConfigListView';
import {NotificationsLayout} from "@/modules/template/components/NotificationsLayout";
import {ErrorBoundary} from "@/shared/components/ErrorBoundary";
import TemplateManagementView from "@/modules/template/views/TemplateManagementView";
import {
    ContextScriptEditView,
    ContextScriptListView,
    ContextScriptViewView,
    ContextTransformationView
} from "@/modules/template";



export const notificationConfigRoutes: RouteObject[] = [
    {
        path: '/notifications/config',
        element: <NotificationConfigListView />,
        errorElement: <ErrorBoundary />
    }
];